exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar {\n  -webkit-transition: right ease-in 500ms;\n  transition: right ease-in 500ms;\n  text-align: center; }\n  .sidebar a {\n    display: inline-block;\n    border-radius: none;\n    border: none;\n    margin: 0.3em;\n    margin-right: 0;\n    background-color: #ad0e68;\n    cursor: pointer;\n    outline: none;\n    -webkit-transition: background-color ease-in 200ms;\n    transition: background-color ease-in 200ms; }\n  .sidebar a:hover {\n      background-color: #dc1284; }\n  .sidebar a img {\n      fill: white;\n      height: 25px;\n      margin: 20px; }\n  .sidebar a img.logo {\n        height: 45px;\n        margin: 10px 15px; }\n  @media (min-width: 720px) {\n  .sidebar {\n    text-align: right;\n    position: fixed;\n    right: 0;\n    left: auto;\n    top: 50vh;\n    bottom: auto;\n    margin: auto; }\n    .sidebar a {\n      display: block; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main